import { Span } from '@chakra-ui/react';
import ReactCountryFlag from 'react-country-flag';
import { COMMON_GEO, geoLabel } from './preference-labels';

/** A country flag glyph sized to sit inline before a chip label. */
const geoFlag = (code: string) => (
  <Span rounded="sm" overflow="hidden" display="inline-flex" flexShrink={0}>
    <ReactCountryFlag
      countryCode={code}
      svg
      style={{ width: '1.1em', height: '1.1em' }}
      aria-hidden
    />
  </Span>
);

/**
 * Geo chip options: the common set unioned with whatever the brand already
 * selected, each carrying its country flag as the `leading` glyph. Single
 * source of truth shared by the onboarding GeoStep and the Settings
 * PreferenceBlocks so flags render identically on both surfaces.
 */
export const buildGeoOptions = (selected: string[] | undefined, lang: string) => {
  const codes = Array.from(new Set([...(selected ?? []), ...COMMON_GEO]));
  return codes.map((code) => ({
    value: code,
    label: geoLabel(code, lang),
    leading: geoFlag(code),
  }));
};
